import React from 'react';
import { useForm as useRHForm } from 'react-hook-form';
import { getComponentDebugName } from '@/js/libs/reatom-devtools';
/** A normal `useForm` from react-hook-form with debug options */
export const useForm = (...a) => {
    const form = useRHForm(...a);
    const name = React.useMemo(() => getComponentDebugName('form'), []);
    React.useEffect(() => {
        if (!DEVTOOLS)
            return () => { };
        const state = DEVTOOLS.state(name, form.getValues());
        // eslint-disable-next-line react-hooks/incompatible-library
        const { unsubscribe: unForm } = form.watch(state);
        // @ts-expect-error generics
        const unDevtools = state.subscribe(form.reset);
        return () => {
            unForm();
            unDevtools();
        };
    }, [form, name]);
    return form;
};
